import axios from '@/libs/api.request'
import { getToken } from '@/libs/util'

export const saveAdminSet = async (that, data) => {
    var res = await axios.request({
        url: '/shop/admin/saveAdminSet',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getAdminSet = async (that, data) => {
    var res = await axios.request({
        url: '/shop/admin/getAdminSet',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const saveInformation = async (that, data) => {
    var res = await axios.request({
        url: '/shop/admin/saveInformation',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getInformation = async (that, data) => {
    var res = await axios.request({
        url: '/shop/admin/getInformation',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const saveInformationCategory = async (that, data) => {
    var res = await axios.request({
        url: '/shop/admin/saveInformationCategory',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getInformationCategory = async (that, data) => {
    var res = await axios.request({
        url: '/shop/admin/getInformationCategory',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
getInformationList
export const getInformationList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/admin/getInformationList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getInformationCategoryList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/admin/getInformationCategoryList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const delInformationCategory = async (that, data) => {
    var res = await axios.request({
        url: '/shop/admin/delInformationCategory',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const delInformation = async (that, data) => {
    var res = await axios.request({
        url: '/shop/admin/delInformation',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getMyShop = async (that, data) => {
    var res = await axios.request({
        url: '/shop/admin/getMyShop',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getMaterialList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/image/getMaterialList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const saveMaterial = async (that, data) => {
    var res = await axios.request({
        url: '/shop/image/saveMaterial',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getMaterial = async (that, data) => {
    var res = await axios.request({
        url: '/shop/image/getMaterial',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const delMaterial = async (that, data) => {
    var res = await axios.request({
        url: '/shop/image/delMaterial',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getFeedbackList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/feedback/getFeedbackList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getFeedback = async (that, data) => {
    var res = await axios.request({
        url: '/shop/feedback/getFeedback',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const delFeedback = async (that, data) => {
    var res = await axios.request({
        url: '/shop/feedback/delFeedback',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getLoginLogList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/admin/getLoginLogList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

// ============================================================
// App 版本配置（loan/admin/app_version）
// ============================================================
const attachToken = (data) => {
    const token = getToken()
    data = data || {}
    if (token) {
        data.token = token
    }
    return data
}

export const getAppVersionList = async (that, data = {}) => {
    data = attachToken(data)
    var res = await axios.request({
        url: '/app/api/admin/version/list',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 200) {
        that.$Message.error(res.msg || '获取版本配置失败')
        if (res.code == 401 || res.code == -2) {
            that.handleLogOut && that.handleLogOut()
            that.$router.push({ name: 'login' })
        }
    }
    return res
}

export const saveAppVersion = async (that, data) => {
    data = attachToken(data)
    var res = await axios.request({
        url: '/app/api/admin/version/update',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 200) {
        that.$Message.error(res.msg || '保存版本配置失败')
        if (res.code == 401 || res.code == -2) {
            that.handleLogOut && that.handleLogOut()
            that.$router.push({ name: 'login' })
        }
    }
    return res
}

export const clearAppVersionCache = async (that, data) => {
    data = attachToken(data)
    var res = await axios.request({
        url: '/app/api/admin/version/clearCache',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 200) {
        that.$Message.error(res.msg || '清理缓存失败')
        if (res.code == 401 || res.code == -2) {
            that.handleLogOut && that.handleLogOut()
            that.$router.push({ name: 'login' })
        }
    }
    return res
}
export const getDistributeMonitorList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/admin/getDistributeMonitorList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}